import { Trans, useTranslation } from "react-i18next";
import { useParallax } from "react-scroll-parallax";
import { Link } from "react-scroll";

import { SectionIds } from "@constants/sectionIds";

import "./Hero.scss";

const Hero = () => {
  const { t } = useTranslation(["landingPage"]);

  const { ref } = useParallax({
    speed: 5,
    scale: [1.8, 1, "easeOutCubic"]
  });

  return (
    <header id={SectionIds.Hero} className="app-hero">
      <div className="app-hero-main">
        <div className="app-hero-content">
          <h1 className="white-space-pre-wrap">
            <Trans
              t={t}
              i18nKey="landingPage:hero.title"
              components={{ span: <span className="skey-gradient-text" /> }}
            />
          </h1>

          <p className="p0 mt-5 description white-space-pre-wrap">
            <Trans
              t={t}
              i18nKey="landingPage:hero.description"
              components={{
                a: (
                  <Link to={SectionIds.SkeyPoap} duration={250} smooth className="p0 blue-1 cursor-pointer">
                    Skey POAP
                  </Link>
                )
              }}
            />
          </p>
        </div>

        <div className="app-hero-preview-image">
          <img
            src="/images/layouts/hero-app-preview-bg-mobile.png"
            alt="background blur"
            className="preview-image-bg-mobile"
          />
          <img
            src="/images/layouts/hero-app-preview-bg-desktop.jpg"
            alt="background blur"
            className="preview-image-bg-desktop"
          />

          <img
            ref={ref as any}
            src="/images/layouts/hero-app-preview-desktop.png"
            alt="App preview"
            className="preview-image-desktop"
          />
        </div>
      </div>
    </header>
  );
};

export default Hero;
